import React, { Component } from 'react';
import Parser from 'html-react-parser'

class First extends Component {
  static defaultProps = {

  }

  state = {

  }

  constructor(props) {
    super(props)


  }

  render() {

    const breadcrumbs = this.props?.breadcrumbs || []

    return (
      <div className='mt-[50px] xl:mt-[60px] w-full'>
        <div className='container text-ptblack text-base'>
          {breadcrumbs.map((item, index) => (
            <>
              {index < breadcrumbs.length - 1 ? (
                <a href={item.item['@id']} className='text-ptgray'>
                  {item.item.name + ' / '}
                </a>
              ) : (
                <span className='text-ptblack'>
                  {item.item.name}
                </span>
              )}
            </>
          ))}
        </div>
      </div>
    )
  }
}

export default First;